var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { ArtAction } from "../action/Action";
import { ArtActionHeading } from "../action/Heading";
import { ArtActionPrice } from "../action/Price";
import { artOverlayHeadingCls, artOverlayHeadingDetailsCls } from "./Header.less";
function ArtOverlayHeader(_ref) {
  var title = _ref.title, artistUrl = _ref.artistUrl, artistName = _ref.artistName, productCanBuy = _ref.productCanBuy, _ref$checkoutProps = _ref.checkoutProps, checkoutProps = _ref$checkoutProps === void 0 ? {} : _ref$checkoutProps, translations = _ref.translations, children = _ref.children;
  var _ref2 = checkoutProps || {}, price = _ref2.price, canBuyInInstalments = _ref2.canBuyInInstalments, instalments = _ref2.instalments;
  return /* @__PURE__ */ React.createElement(ArtAction, {
    className: artOverlayHeadingCls
  }, /* @__PURE__ */ React.createElement("div", {
    className: artOverlayHeadingDetailsCls
  }, /* @__PURE__ */ React.createElement(ArtActionHeading, {
    title,
    artistUrl,
    artistName,
    translations
  })), productCanBuy && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ArtActionPrice, {
    price,
    canBuyInInstalments,
    instalments
  }), children));
}
__name(ArtOverlayHeader, "ArtOverlayHeader");
export {
  ArtOverlayHeader
};
